import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'antd'
import * as S from './styles'
import { USER_CACHE_EVENT, getUserCachedData } from 'utils/UserAuthorization'

// Nome no topo: clicar leva direto ao Meu perfil (dados, OAB, senha, preferências)
function Profile() {
  const navigate = useNavigate()
  const [userData, setUserData] = useState(getUserCachedData)
  // nome atualizado no perfil aparece aqui sem recarregar
  useEffect(() => {
    const atualizar = () => setUserData(getUserCachedData())
    window.addEventListener(USER_CACHE_EVENT, atualizar)
    return () => window.removeEventListener(USER_CACHE_EVENT, atualizar)
  }, [])
  const companyName = userData?.company?.nome || userData?.company?.name || ''
  const initials = (userData?.first_name?.[0] || '') + (userData?.last_name?.[0] || '')
  const abrir = () => navigate('/perfil')

  return (
    <Tooltip title='Meu perfil' placement='bottomRight'>
      <S.UserProfileBlueGray role='link' tabIndex={0} style={{ cursor: 'pointer' }} onClick={abrir} onKeyDown={(e) => { if (e.key === 'Enter') abrir() }} aria-label='Abrir meu perfil'>
        <S.AvatarBlueGray>{userData?.foto ? <img src={userData.foto} alt='' /> : initials ? initials.toUpperCase() : <S.IconUser />}</S.AvatarBlueGray>
        <S.UserTextBlueGray>
          <div>Olá, <span>{userData?.first_name || 'Usuário'}</span></div>
          {companyName && <S.CompanyTextBlueGray title={companyName}>{companyName}</S.CompanyTextBlueGray>}
        </S.UserTextBlueGray>
      </S.UserProfileBlueGray>
    </Tooltip>
  )
}
export default Profile
